module.exports = __webpack_public_path__ + "02_short_black.be520f23.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/02_short_black.png
// module id = uIWQ
// module chunks = 0